function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QIcon from '../icon/QIcon.js';
import RippleMixin from '../../mixins/ripple.js';
import ListenersMixin from '../../mixins/listeners.js';
import { stop, prevent, stopAndPrevent } from '../../utils/event.js';
import { mergeSlot } from '../../utils/slot.js';
import { shouldIgnoreKey } from '../../utils/key-composition.js';
var uid = 0;
export default Vue.extend({
  name: 'QTab',
  mixins: [RippleMixin, ListenersMixin],
  inject: {
    tabs: {
      "default": function _default() {
        console.error('QTab/QRouteTab components need to be child of QTabs');
      }
    },
    __activateTab: {},
    __recalculateScroll: {},
    __onKbdNavigate: {}
  },
  props: {
    icon: String,
    label: [Number, String],
    alert: [Boolean, String],
    alertIcon: String,
    name: {
      type: [Number, String],
      "default": function _default() {
        return "t_".concat(uid++);
      }
    },
    noCaps: Boolean,
    tabindex: [String, Number],
    disable: Boolean,
    contentClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.tabs.current === this.name;
    },
    classes: function classes() {
      var _ref;

      return _objectSpread(_objectSpread({}, this.isActive === true ? (_ref = {
        'q-tab--active': true
      }, _defineProperty(_ref, this.tabs.activeClass, this.tabs.activeClass), _defineProperty(_ref, "text-".concat(this.tabs.activeColor), this.tabs.activeColor), _defineProperty(_ref, "bg-".concat(this.tabs.activeBgColor), this.tabs.activeBgColor), _ref) : {
        'q-tab--inactive': true
      }), {}, {
        'q-tab--full': this.icon && this.label && !this.tabs.inlineLabel,
        'q-tab--no-caps': this.noCaps === true || this.tabs.noCaps === true,
        'q-focusable q-hoverable cursor-pointer': !this.disable,
        disabled: this.disable
      });
    },
    innerClass: function innerClass() {
      return (this.tabs.inlineLabel === true ? 'row no-wrap q-tab__content--inline' : 'column') + (this.contentClass !== void 0 ? " ".concat(this.contentClass) : '');
    },
    computedTabIndex: function computedTabIndex() {
      return this.disable === true || this.tabs.hasFocus === true ? -1 : this.tabindex || 0;
    },
    computedRipple: function computedRipple() {
      return this.ripple === false ? false : Object.assign({
        keyCodes: [13, 32],
        early: true
      }, this.ripple === true ? {} : this.ripple);
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({
        input: stop
      }, this.qListeners), {}, {
        click: this.__activate,
        keydown: this.__onKeydown
      });
    },
    attrs: function attrs() {
      var attrs = {
        tabindex: this.computedTabIndex,
        role: 'tab',
        'aria-selected': this.isActive === true ? 'true' : 'false'
      };

      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }

      return attrs;
    }
  },
  methods: {
    __activate: function __activate(e, keyboard) {
      if (keyboard !== true && this.$refs.blurTarget !== void 0) {
        this.$refs.blurTarget.focus({
          preventScroll: true
        });
      }

      if (this.disable !== true) {
        this.qListeners.click !== void 0 && this.$emit('click', e);

        this.__activateTab(this.name);
      }
    },
    __onKeydown: function __onKeydown(e) {
      if (shouldIgnoreKey(e)) {
        return;
      }

      if ([13, 32].indexOf(e.keyCode) !== -1) {
        this.__activate(e, true);

        prevent(e);
      } else if (e.keyCode >= 35 && e.keyCode <= 40) {
        this.__onKbdNavigate(e.keyCode, this.$el) === true && stopAndPrevent(e);
      }
    },
    __getContent: function __getContent(h) {
      var narrow = this.tabs.narrowIndicator,
          content = [],
          indicator = h('div', {
        staticClass: 'q-tab__indicator',
        "class": this.tabs.indicatorClass
      });
      this.icon !== void 0 && content.push(h(QIcon, {
        staticClass: 'q-tab__icon',
        props: {
          name: this.icon
        }
      }));
      this.label !== void 0 && content.push(h('div', {
        staticClass: 'q-tab__label'
      }, [this.label]));
      this.alert !== false && content.push(this.alertIcon !== void 0 ? h(QIcon, {
        staticClass: 'q-tab__alert-icon',
        props: {
          color: this.alert !== true ? this.alert : void 0,
          name: this.alertIcon
        }
      }) : h('div', {
        staticClass: 'q-tab__alert',
        "class": this.alert !== true ? "text-".concat(this.alert) : null
      }));
      narrow === true && content.push(indicator);
      var node = [h('div', {
        staticClass: 'q-focus-helper',
        attrs: {
          tabindex: -1
        },
        ref: 'blurTarget'
      }), h('div', {
        staticClass: 'q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable',
        "class": this.innerClass
      }, mergeSlot(content, this, 'default'))];
      narrow === false && node.push(indicator);
      return node;
    },
    __renderTab: function __renderTab(h, tag) {
      var _this = this;

      var data = {
        staticClass: 'q-tab relative-position self-stretch flex flex-center text-center no-outline',
        "class": this.classes,
        attrs: this.attrs,
        directives: this.ripple === false || this.disable === true ? null : [{
          name: 'ripple',
          value: this.computedRipple
        }]
      };

      if (this.hasRouterLink === true) {
        return h(tag, _objectSpread(_objectSpread({}, data), {}, {
          nativeOn: this.onEvents,
          props: this.routerTabLinkProps,
          scopedSlots: {
            "default": function _default(_ref2) {
              var _class;

              var href = _ref2.href,
                  isActive = _ref2.isActive,
                  isExactActive = _ref2.isExactActive;
              return h('a', {
                "class": (_class = {}, _defineProperty(_class, _this.activeClass, isActive), _defineProperty(_class, _this.exactActiveClass, isExactActive), _class),
                attrs: _objectSpread(_objectSpread({}, _this.linkProps.attrs), {}, {
                  href: href
                })
              }, _this.__getContent(h));
            }
          }
        }));
      }

      if (this.hasLink === true) {
        Object.assign(data.attrs, this.linkProps.attrs);
        data.props = this.linkProps.props;
      }

      data.on = this.onEvents;
      return h(tag, data, this.__getContent(h));
    }
  },
  mounted: function mounted() {
    this.__recalculateScroll();
  },
  beforeDestroy: function beforeDestroy() {
    this.__recalculateScroll();
  },
  render: function render(h) {
    return this.__renderTab(h, 'div');
  }
});